const socialMedia = [
  {
    icon: <i className="fab fa-facebook-f"></i>,
    id: 1,
    url: "https://www.facebook.com/nextcosmostechnology",
  },
  {
    icon: <i className="fab fa-twitter"></i>,
    id: 1,
    url: "https://x.com/NextCosmosTech",
  },
  {
    icon: <i className="fab fa-linkedin"></i>,
    id: 2,
    url: "https://www.linkedin.com/company/nextcosmostechnology",
  },
  {
    icon: <i className="fab fa-instagram"></i>,
    id: 3,
    url: "https://www.instagram.com/next_cosmos_technology",
  },
  {
    icon: <i className="fab fa-pinterest-p"></i>,
    id: 4,
    url: "https://in.pinterest.com/NextCosmosTechnology",
  },
  {
    icon: <i className="fab fa-youtube"></i>,
    id: 5,
    url: "https://www.youtube.com/@NextCosmosTechnology",
  },
];

const SocialMedial = () => {
  return (
    <>
      {socialMedia.map(({ id, icon, url, target }, indx) => (
        <a href={url} target={target ? target : "blank"} key={id+indx}>
          {icon}
        </a>
      ))}
    </>
  );
};

export default SocialMedial;
